import { Navigate, Outlet } from "react-router-dom";
import { getUserPriority } from "../../services/authService";

interface ProtectedRouteProps {
  allowedRoles: number[];
  redirectTo?: string;
}

const ProtectedRoute = ({ allowedRoles }: ProtectedRouteProps) => {
  const userPriority = getUserPriority();

  // Not logged in at all → back to login
  if (!userPriority) {
    return <Navigate to="/login" replace />;
  }

  // Logged in but role not permitted → redirect
  if (!allowedRoles.includes(userPriority as number)) {
    return <Navigate to="/customer/overview" replace />;
  }

  // Role is permitted → render child routes
  return <Outlet />;
};

export default ProtectedRoute;